/* istanbul ignore file */
export * from './ZeroResultsNoticeMessage';
